import { fileUrl } from "../lib/api";

const COLORS = { current: "bg-rose-600 ring-rose-300", done: "bg-emerald-600 ring-emerald-300", todo: "bg-gray-700 ring-gray-400" };

export const PlanMap = ({ plan, pins, onPinClick, onPlace, testid = "plan-map" }) => {
  const place = (e) => {
    if (!onPlace) return;
    const r = e.currentTarget.getBoundingClientRect();
    onPlace(Math.round(((e.clientX - r.left) / r.width) * 1000) / 10, Math.round(((e.clientY - r.top) / r.height) * 1000) / 10);
  };
  return (
    <div className={`relative overflow-hidden rounded-md bg-white ${onPlace ? "cursor-crosshair" : ""}`} onClick={place} data-testid={testid}>
      <img src={fileUrl(plan)} alt="Site plan" className="block w-full select-none" draggable={false} />
      {pins.map((p) => (
        <button key={p.id} type="button" onClick={(e) => { e.stopPropagation(); onPinClick?.(p); }} data-testid={`${testid}-pin-${p.code}`}
          style={{ left: `${p.x}%`, top: `${p.y}%` }}
          className={`absolute flex -translate-x-1/2 -translate-y-full flex-col items-center`}>
          <span className={`flex h-8 min-w-[32px] items-center justify-center rounded-full px-1.5 font-mono text-xs font-bold text-white shadow-lg ring-2 ${COLORS[p.state || "todo"]}`}>{p.label}</span>
          <span className="mt-0.5 h-2 w-0.5 bg-gray-900" />
          <span className="whitespace-nowrap rounded bg-gray-900/85 px-1.5 py-0.5 text-[10px] text-white">{p.name}</span>
        </button>
      ))}
    </div>
  );
};
